import React from 'react';
import { useExportSnippetsMutation } from './mutations';
import { useProject } from '../projects/queries';
import { useAllProjectTranscripts } from '../transcripts/queries';
import { useDescriptors } from '../descriptors/queries';
import { useCodes } from '../codes/queries';
import { useProjectUsers } from '../users/queries';

/**
 * Hook for snippet export (used in AnalysisExportModal)
 * Accepts filters as a parameter for flexibility
 */
export function useSnippetExport(projectId, filters = {}) {
  const { data: projectData, isLoading: projectLoading } = useProject(projectId);
  const { data: transcripts, isLoading: transcriptsLoading } = useAllProjectTranscripts(projectId);
  const { data: descriptorsData, isLoading: descriptorsLoading } = useDescriptors(projectId);
  const { data: codesData, isLoading: codesLoading } = useCodes(projectId);
  const { data: usersData, isLoading: usersLoading } = useProjectUsers(projectId);
  const mutation = useExportSnippetsMutation(projectData, descriptorsData, codesData?.codes, usersData, transcripts, filters);

  return {
    exportSnippets: () => mutation.mutate(),
    isExporting: mutation.isPending,
    error: mutation.error,
    isReady: !!projectId && !projectLoading && !!projectData && !transcriptsLoading && !descriptorsLoading && !codesLoading && !usersLoading
  };
}